import {
  customizeError,
  getResponseQuery,
  getResponseData
} from "@helpers/_functions";

import http from "../http-common";
import BaseService from "./base.service";

class EmployerService extends BaseService {
  constructor() {
    super("employes");
  }
  getByUserId(id, params = {}) {
    return http
      .get(`${this.path}/list/${id}`, { params })
      .then((response) => response.data.data?.[0]);
  }
  getEmailsAndEmployeeNumber(id, params = {}) {
    return http
      .get(`${this.path}/emails-and-employee-number/${id}`, { params })
      .then((response) => response.data.data?.[0]);
  }

  getByIdWithNethris(id) {
    return http
      .get(`${this.path}/getById-with-nethris/${id}`)
      .then((response) => getResponseData(response));
  }

  changeStatusOrLang(item, id) {
    return http.put(`${this.path}/change/${id}`, item);
  }

  getListEmployerFiltered(id, params = {}) {
    return http.get(`${this.path}/listFiltered/${id}`, { params });
  }

  getListEmployerFilteredBulk(id) {
    return http.get(`${this.path}/listFilteredBulk/${id}`);
  }

  getListEmployerToExport(filters = {}, params = {}) {
    const adminId = localStorage.getItem("idAdminEnterprise");
    return getResponseQuery(
      http.get(`${this.path}/export-data/${adminId}/${filters}`, { params })
    );
  }

  getWorkingHoursSummaryToExport(id, filters = "", params = {}) {
    params = {
      ...params,
      ...JSON.parse(filters)
    };
    return http.get(`${this.path}/export-recap/${id}`, { params });
  }

  getEmployeStatistics(adminId, filter, params = {}) {
    filter = JSON.stringify(filter);
    return http.get(`${this.path}/statistics/${adminId}/${filter}`, { params });
  }

  getStatisticsIndisponibility(
    adminId = localStorage.getItem("idAdminEnterprise"),
    filter = {}
  ) {
    return http.get(
      `${this.path}/periode_statistics_indisponibility/${adminId}`,
      { params: filter }
    );
  }

  getSalaryStatistics(adminId, params = {}, filter) {
    filter = JSON.stringify(filter);
    return http.get(`${this.path}/salary-statistics/${adminId}/${filter}`, {
      params
    });
  }

  getSalaryEvolution(adminId, params = {}, filter) {
    filter = JSON.stringify(filter);
    return http.get(`${this.path}/salary-evolution/${adminId}/${filter}`, {
      params
    });
  }
  getSalaryEvolutionsByYears(adminId, params = {}, filter) {
    filter = JSON.stringify(filter);
    return http.get(
      `${this.path}/salary-evolution-by-years/${adminId}/${filter}`,
      {
        params
      }
    );
  }
  getByEmplacement = (emplacemetId) => {
    return http.get(`${this.path}/getByEmplacement/${emplacemetId}`);
  };

  importLists(data) {
    return http
      .post(`${this.path}/import`, data)
      .then((response) => response.data.data)
      .catch((err) => Promise.reject(customizeError(err)));
  }
  downloadGabarit() {
    return http.get(`${this.path}/gabarit`, {
      responseType: "blob"
    });
  }
  saveLists(data) {
    return http
      .post(`${this.path}/save`, data)
      .then((response) => response.data.data)
      .catch((err) => Promise.reject(customizeError(err)));
  }
  createEmployer = (dataEmployer) => {
    return http.post(`${this.path}/create-new-employee`, dataEmployer);
  };
  createEmployers = (employers, userId, enterpriseId) => {
    return http.post(
      `${this.path}/add-multiple/${userId}/${enterpriseId}`,
      employers
    );
  };
  updateEmployers = (employers, userId, enterpriseId) => {
    return http.post(
      `${this.path}/update-multiple/${userId}/${enterpriseId}`,
      employers
    );
  };
  export(data) {
    return http.post(`${this.path}/export`, data);
  }

  download(theFileName) {
    return http.get(
      `${this.path}/download/${localStorage.getItem("enterpriseId")}/${theFileName}`,
      {
        responseType: "blob"
      }
    );
  }

  getByEmployerAccess(userId, params = {}) {
    return http
      .get(`${this.path}/employer-access/${userId}`, { params })
      .then((response) => response.data.data);
  }

  getEmployerHierarchical(id) {
    return http.get(`${this.path}/get-employer-hierarchical/${id}`);
  }
  //last

  upsertHealthPrecision(body) {
    return http.post(`${this.path}/health-precision-option/upsert`, body);
  }

  deleteHealthById(id) {
    return http.delete(`${this.path}/health-precision-option/deleteById/${id}`);
  }

  getHealthByEnterprise(id) {
    return http.get(
      `${this.path}/health-precision-option/getByEnterprise/${id}`
    );
  }
  upsertClothes(body) {
    return http.post(`${this.path}/clothes/upsert`, body);
  }

  deleteClothesById(id) {
    return http.delete(`${this.path}/clothes/deleteById/${id}`);
  }

  getClothesByEnterprise(id) {
    return http.get(`${this.path}/clothes/getByEnterprise/${id}`);
  }

  getByGroupsEmplacements(body) {
    return http.post(`${this.path}/groups-emplacements`, body);
  }

  bulkUpdatePersonalInfo(payload) {
    return http.post(`${this.path}/bulk-update-personalInfo`, payload);
  }

  bulkUpdateEmailsAndPhones(payload) {
    return http.post(`${this.path}/bulk-update-emailsAndPhones`, payload);
  }

  bulkUpdateAddress(payload) {
    return http.post(`${this.path}/bulk-update-address`, payload);
  }

  bulkUpdateHealth(payload) {
    return http.post(`${this.path}/bulk-update-health`, payload);
  }

  bulkUpdateClothes(payload) {
    return http.post(`${this.path}/bulk-update-clothes`, payload);
  }

  bulkUpdateFirstEmergency(payload) {
    return http.post(`${this.path}/bulk-update-firstEmergency`, payload);
  }

  bulkUpdateSecondEmergency(payload) {
    return http.post(`${this.path}/bulk-update-secondEmergency`, payload);
  }

  bulkUpdateAdditionalInfo(payload) {
    return http.post(`${this.path}/bulk-update-additionalInfo`, payload);
  }
}

export default new EmployerService();
